import { forwardRef } from 'react';
import { DeckardIcon, DeckardIconProps } from './DeckardIcon';

export const WorkspaceIcon: DeckardIcon = forwardRef<SVGSVGElement, DeckardIconProps>(
  ({ circle, double, size = 24, color = 'currentColor', ...props }, ref) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      color={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="deckard-icon"
      {...props}
    >
      <path
        stroke="currentColor"
        d="M 21 15.998 L 21 7.998 C 20.999 7.647 20.907 7.302 20.731 6.999 C 20.556 6.695 20.303 6.443 20 6.268 L 13 2.268 C 12.696 2.092 12.351 2 12 2 C 11.649 2 11.304 2.092 11 2.268 L 4 6.268 C 3.696 6.443 3.444 6.695 3.268 6.999 C 3.093 7.302 3 7.647 3 7.998 L 3 15.998 C 3 16.348 3.093 16.693 3.268 16.996 C 3.444 17.3 3.696 17.552 4 17.728 L 11 21.728 C 11.304 21.903 11.649 21.996 12 21.996 C 12.351 21.996 12.696 21.903 13 21.728 L 20 17.728 C 20.303 17.552 20.556 17.3 20.731 16.996 C 20.907 16.693 20.999 16.348 21 15.998 Z"
        transform="matrix(1, 0, 0, 1, -1.4210854715202004e-14, 0)"
      />
      <path
        stroke="currentColor"
        d="M 3.27 6.958 L 12 12.008 L 20.73 6.958"
        transform="matrix(1, 0, 0, 1, -1.4210854715202004e-14, 0)"
      />
      <path
        stroke="currentColor"
        d="M 12 22.078 L 12 11.998"
        transform="matrix(1, 0, 0, 1, -1.4210854715202004e-14, 0)"
      />
      <path
        stroke="currentColor"
        d="M 17 14.278 L 17 9.831 C 17 9.638 16.948 9.444 16.85 9.278 C 16.751 9.108 16.611 8.968 16.446 8.87 L 12.554 6.65 C 12.388 6.55 12.194 6.5 12 6.5 C 11.804 6.5 11.611 6.55 11.444 6.65 L 7.554 8.87 C 7.388 8.968 7.248 9.108 7.15 9.278 C 7.051 9.444 7 9.638 7 9.831 L 7 14.278 C 7 14.47 7.051 14.661 7.15 14.83 C 7.248 15 7.388 15.14 7.554 15.238 L 11.444 17.46 C 11.611 17.558 11.804 17.61 12 17.61 C 12.194 17.61 12.388 17.558 12.554 17.46 L 16.446 15.238 C 16.611 15.14 16.751 15 16.85 14.83 C 16.948 14.661 17 14.47 17 14.278 Z"
        transform="matrix(1, 0, 0, 1, -1.4210854715202004e-14, 0)"
      />
      <line
        stroke="currentColor"
        x1="7.123"
        y1="14.926"
        x2="3.304"
        y2="17.201"
        transform="matrix(1, 0, 0, 1, -1.4210854715202004e-14, 0)"
      />
      <line
        stroke="currentColor"
        x1="17.035"
        y1="14.845"
        x2="20.854"
        y2="17.12"
        transform="matrix(1, 0, 0, 1, -1.4210854715202004e-14, 0)"
      />
      <line
        stroke="currentColor"
        x1="11.916"
        y1="6.395"
        x2="11.916"
        y2="2.089"
        transform="matrix(1, 0, 0, 1, -1.4210854715202004e-14, 0)"
      />
    </svg>
  ),
);
